var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowPrevious = function SvgArrowPrevious(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.789 173.304 4.162 100.722l78.156-74.027 5.518 5.828-72.009 68.199 70.48 66.745-5.518 5.837z"
  })));
};
export default SvgArrowPrevious;